// main.js
import React from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import cx from "classnames";
import UI    from "UI"
import PropTypes from 'prop-types';
import RCore from "RCore";

class SimpleEventHeader extends React.Component {

    constructor(props) {
        super(props);

        this.i18dict = i18;
        this.i18 = RCore.i18.bind(this);
    }

    static defaultProps = {
        type: 'default',
        useShortNames: false
    };

    static contextTypes = {
        screenSizeObserver: PropTypes.object,
        info: PropTypes.object,
        teamLogoSettings: PropTypes.object
    };

    componentDidMount() {
      this.context.screenSizeObserver.subscribe(() => this.forceUpdate())
    }

    renderTeam = (side) => {
        let {event = {}, useShortNames} = this.props;
        let media = this.context.screenSizeObserver;

        let name = event[`${side}Name`] || UI.nbsp;
        let formation = this.props[`${side}Formation`];

        if (media.isXS() || media.isSM() || useShortNames === 'true' || useShortNames === true) {
            name = event[`${side}ShortName`] || name.substr(0, 3).toUpperCase() || name;
        }

        return (
            <div className={`wdp-simple-eh__team wdp-simple-eh__team_${side}`}>
                {side == 'away' && <span className="wdp-simple-eh__name">{formation ? `${formation} ` : null}{name}</span>}
                <UI.TeamLogo teamId={event[`${side}Id`]} />
                {side == 'home' && <span className="wdp-simple-eh__name">{name}{formation ? ` ${formation}` : null}</span>}
            </div>
        )
    };

    render() {
        let {additionalClasses = {}} = this.props;

        // if (_.isEmpty(event)) return this.renderStub();

        let wrapperClasses = cx({
            'wdp-simple-eh': true,
            ...additionalClasses
        });

        return (
            <div className={wrapperClasses}>
                {this.renderTeam('home')}
                {this.renderTeam('away')}
            </div>
        )
    }
}

const i18 = SimpleEventHeader.i18 = {
    'en': {

    },
    'da': {

    }
};

export default SimpleEventHeader;
export {SimpleEventHeader, i18};


/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/SimpleEventHeader.js
 **/